import {initialState} from './contants'
export default {
	viewModel: initialState(),
	notes: [],
	loadingNote: false,
	loadingReservation: false,
	quote:{
		showForm:false
	},
	loadingReviews: false,
	reviews: []
};
